export default __webpack_public_path__ + "161fd3df3be6c30e8cad549c044ec932.jpg";